// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { PopoverTokens } from './type';

const popoverTokens: PopoverTokens = {
  popoverFontSize: 'Font-14',
  popoverFontWeight: 'Weight-regular',
  popoverFontColor: 'Neutral-text-5',
  popoverPaddingX: 'Spacing-8',
  popoverPaddingY: 'Spacing-8',
  popoverRadius: 'Radius-default',
  popoverBorderWidth: 'Border-1',
  popoverBorderColor: 'Neutral-border-1',
  popoverBackgroundColor: 'Neutral-fill-1',
  popoverShadow: 'Shadow-2',
  popoverSuccessBackgroundColor: 'Success-1',
  popoverSuccessBorderColor: 'Success-2',
  popoverWarningBackgroundColor: 'Warning-1',
  popoverWarningBorderColor: 'Warning-2',
  popoverInfoBackgroundColor: 'Brand-1',
  popoverInfoBorderColor: 'Brand-2',
  popoverDangerBackgroundColor: 'Danger-1',
  popoverDangerBorderColor: 'Danger-2',
  popoverErrorFontColor: 'Danger-7',
  popoverErrorBackgroundColor: 'Danger-1',
  popoverErrorBorderColor: 'Danger-1',
  popoverConfirmPaddingX: 'Spacing-16',
  popoverConfirmPaddingY: 'Spacing-16',
  popoverConfirmMarginY: 'Spacing-16',
  popoverConfirmBackgroundColor: 'transparent',
  popoverConfirmTitleFontSize: 'Font-14',
};

export default popoverTokens;
